import MentoringTeamCard from './MentoringTeamCard.vue';
import { Child } from './components';

export { Child };
export * from './types';
export default MentoringTeamCard;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/mentoring/teamcard/index.ts